import React, { useEffect, useState } from "react";
import { useT } from "@/i18n/i18n";
import { useAuth } from "@/context/AuthContext";
import api, { formatApiError } from "@/lib/api";
import { PageTitle, Panel, Btn, Field, Input, Select, Textarea, DataTable, toast } from "@/pages/app/kit";

export default function GovernancePage() {
  const { t, lang } = useT();
  const L = (pl, en) => (lang === "pl" ? pl : en);
  const { user } = useAuth();
  const isAdmin = ["admin", "super_admin"].includes(user.role);
  const [conflicts, setConflicts] = useState([]);
  const [market, setMarket] = useState([]);
  const [wb, setWb] = useState([]);
  const [cf, setCf] = useState({ related_type: "supplier", entity_name: "", description: "" });
  const [mf, setMf] = useState({ category: "price", region: "lubelskie", description: "" });

  const load = () => {
    api.get("/conflicts").then((r) => setConflicts(r.data)).catch(() => {});
    api.get("/market-integrity").then((r) => setMarket(r.data)).catch(() => {});
    if (isAdmin) api.get("/whistleblower").then((r) => setWb(r.data)).catch(() => {});
  };
  useEffect(() => { load(); }, []);

  const addConflict = async (e) => { e.preventDefault(); try { await api.post("/conflicts", cf); toast.success("OK"); setCf({ related_type: "supplier", entity_name: "", description: "" }); load(); } catch (err) { toast.error(formatApiError(err.response?.data?.detail)); } };
  const addMarket = async (e) => { e.preventDefault(); try { await api.post("/market-integrity", mf); toast.success("OK"); setMf({ category: "price", region: "lubelskie", description: "" }); load(); } catch (err) { toast.error(formatApiError(err.response?.data?.detail)); } };

  return (
    <div>
      <PageTitle title={t("dashboard.governance")} subtitle={L("Ład, uczciwość rynku i przeciwdziałanie nadużyciom","Governance, market integrity and anti-fraud")} />
      <div className="grid gap-6 lg:grid-cols-2">
        <Panel title={L("Deklaracja konfliktu interesów","Conflict-of-interest declaration")}>
          <form onSubmit={addConflict} className="space-y-3">
            <Field label={L("Typ powiązania","Related type")}><Select value={cf.related_type} onChange={(e) => setCf({ ...cf, related_type: e.target.value })}>{["company","family","ownership","supplier","processor","buyer","logistics","investor"].map((x)=><option key={x}>{x}</option>)}</Select></Field>
            <Field label={L("Nazwa podmiotu","Entity name")}><Input value={cf.entity_name} onChange={(e) => setCf({ ...cf, entity_name: e.target.value })} /></Field>
            <Field label={L("Opis","Description")} required><Textarea rows={2} value={cf.description} onChange={(e) => setCf({ ...cf, description: e.target.value })} required /></Field>
            <Btn type="submit" data-testid="conflict-submit">{t("cta.submit")}</Btn>
          </form>
          <div className="mt-4">
            <DataTable columns={[{ key: "related_type", label: "Type" }, { key: "entity_name", label: "Entity" }, { key: "declared_by_name", label: "By" }]} rows={conflicts} empty={t("empty")} testid="conflicts-table" />
          </div>
        </Panel>

        <Panel title={L("Zgłoszenie integralności rynku","Market integrity report")}>
          <form onSubmit={addMarket} className="space-y-3">
            <Field label={L("Kategoria","Category")}><Select value={mf.category} onChange={(e) => setMf({ ...mf, category: e.target.value })}>{["price","imported product","origin-label","below-market","cancellation","late-payment","complaint"].map((x)=><option key={x}>{x}</option>)}</Select></Field>
            <Field label={L("Opis","Description")} required><Textarea rows={2} value={mf.description} onChange={(e) => setMf({ ...mf, description: e.target.value })} required /></Field>
            <p className="text-xs text-mutedtext">{L("Nie oskarżamy konkretnych podmiotów bez zweryfikowanych dowodów.","We do not accuse specific parties without verified evidence.")}</p>
            <Btn type="submit" data-testid="market-submit">{t("cta.submit")}</Btn>
          </form>
          <div className="mt-4">
            <DataTable columns={[{ key: "category", label: "Category" }, { key: "description", label: "Description" }, { key: "status", label: "Status" }]} rows={market} empty={t("empty")} testid="market-table" />
          </div>
        </Panel>
      </div>

      {isAdmin && (
        <Panel title={L("Zgłoszenia sygnalistów (poufne)","Whistleblower reports (confidential)")} className="mt-6">
          <DataTable columns={[{ key: "category", label: "Category" }, { key: "description", label: "Description" }, { key: "status", label: "Status" }, { key: "anonymous", label: "Anon", render: (r) => r.anonymous ? "yes" : "no" }]} rows={wb} empty={t("empty")} testid="wb-table" />
        </Panel>
      )}
    </div>
  );
}
